"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.State = exports.ItemType = exports.SourceSystem = void 0;
var SourceSystem;
(function (SourceSystem) {
    SourceSystem["ECOMR2"] = "ecomR2";
    SourceSystem["ECOMR4"] = "ecomR4";
})(SourceSystem = exports.SourceSystem || (exports.SourceSystem = {}));
var ItemType;
(function (ItemType) {
    ItemType["RECIPE"] = "recipe";
    ItemType["USFPRODUCT"] = "usfProduct";
    ItemType["NONUSFPRODUCT"] = "nonUsfProduct";
})(ItemType = exports.ItemType || (exports.ItemType = {}));
var State;
(function (State) {
    State["PRIVATE"] = "private";
    State["INTERNAL"] = "internal";
    State["PUBLIC"] = "public";
})(State = exports.State || (exports.State = {}));
